import moment from 'moment';

import { Store } from '.';
import { SessionBI } from '../../types';

export type SessionSlice = {
  sessionBI: SessionBI;
  setSessionBI: (sessionBI: SessionBI) => void;
};

export const getSessionInitialState = (
  set: (stateUpdater: (state: Store) => Partial<Store>) => void
): SessionSlice => ({
  sessionBI: {
    lastSessionDate: moment(),
    selfServiceSessionId: null,
  },
  setSessionBI: (sessionBI: SessionBI) => {
    set((state: Store) => ({
      sessionSlice: {
        ...state.sessionSlice,
        sessionBI,
      },
    }));
  },
});
